import React from 'react';

import { faMapPin, faBus } from '@fortawesome/free-solid-svg-icons';
import { useSelector, useDispatch } from 'react-redux';
import { useMap } from 'react-map-gl';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  setDirectionsDestination,
  setDirectionsOrigin,
} from 'handimap-react-lib/store/actions/directionsActions';
import { setMultimodal } from 'handimap-react-lib/store/actions/profilActions';
import { CustomInput } from 'handimap-react-lib/components/CustomInput';
import { CustomSwitcher } from 'handimap-react-lib/components/CustomSwitcher';
import { ScheduleSelector } from 'handimap-react-lib/components/ScheduleSelector';
import { GeocoderInput } from '../components/GeocoderInput';

const Directions = (props) => {
  const { isMobile, styles, multimodalActivated = true } = props;
  const { mymap } = useMap();
  const { t } = useTranslation();
  const originInputValue = useSelector((state) => {
    return {
      label: state.directions.origin.label,
      value: state.directions.origin.marker,
    };
  });

  const destinationInputValue = useSelector((state) => {
    return {
      label: state.directions.destination.label,
      value: state.directions.destination.marker,
    };
  });

  const multimodalValue = useSelector((state) => state.profils.multimodal);

  const dispatch = useDispatch();

  const onSetOrigin = (label, center) => {
    dispatch(setDirectionsOrigin(center, label));
    if (Array.isArray(center) && center.length > 0) {
      mymap?.flyTo({ center: center, duration: 500, zoom: 15 });
    }
  };

  const onSetDestination = (label, center) => {
    dispatch(setDirectionsDestination(center, label));
    if (Array.isArray(center) && center.length > 0) {
      mymap?.flyTo({ center: center, duration: 500, zoom: 15 });
    }
  };

  const onSetMultimodal = (value) => {
    dispatch(setMultimodal(value));
  };

  return (
    <div>
      <Stack direction='column' spacing={2}>
        <CustomInput
          htmlTag='origin'
          icon={faMapPin}
          id='origin-label'
          label={t('form.departure-label')}
        >
          <GeocoderInput
            id='origin'
            labelId='origin-label'
            placeholder={
              isMobile
                ? t('form.mobile-placeholder-departure')
                : t('form.desktop-placeholder-departure')
            }
            onComplete={onSetOrigin}
            inputValue={originInputValue}
            ariaLabelledBy='originInput'
          />
        </CustomInput>
        <CustomInput
          htmlTag='destination'
          icon={faMapPin}
          id='destination-label'
          label={t('form.arrival-label')}
        >
          <GeocoderInput
            id='destination'
            labelId='destination-label'
            placeholder={
              isMobile
                ? t('form.mobile-placeholder-arrival')
                : t('form.desktop-placeholder-arrival')
            }
            onComplete={onSetDestination}
            inputValue={destinationInputValue}
          />
        </CustomInput>
        {multimodalActivated && (
          <ScheduleSelector multimodal={multimodalValue} />
        )}
        {multimodalActivated && (
          <CustomSwitcher
            idSwitcher='switchTransport'
            label={t('form.transport-label')}
            icon={faBus}
            htmlTag='switchTransport'
            dataCy='switch-transport'
            defaultValue={multimodalValue}
            callBackFunction={onSetMultimodal}
            primary={styles.primary}
            primaryContrast={styles.primaryContrast}
            secondary={styles.secondary}
            secondaryContrast={styles.secondaryContrast}
          />
        )}
      </Stack>
    </div>
  );
};

export default Directions;
